(function () {
  'use strict';

  var RECIFE_MIN = 50000000;
  var RECIFE_MAX = 52999999;
  var JABOATAO_MIN = 54000000;
  var JABOATAO_MAX = 54499999;
  var CART_ZIP_STORAGE_KEY = 'polly_shipping_zip';

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function digits(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 8);
  }

  function inRange(zip, min, max) {
    var number = Number(zip);
    return number >= min && number <= max;
  }

  function isRecife(zip) {
    return inRange(zip, RECIFE_MIN, RECIFE_MAX);
  }

  function isUberArea(zip) {
    return isRecife(zip) || inRange(zip, JABOATAO_MIN, JABOATAO_MAX);
  }

  function normalized(value) {
    var text = String(value || '').toLowerCase();
    if (text.normalize) text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return text;
  }

  function cartZipInput(target) {
    return target && target.closest ? target.closest('[data-polly-shipping-zip]') : null;
  }

  function hardenCartZipInput(input) {
    if (!input) return;
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('spellcheck', 'false');
  }

  function forgetStoredCartZip() {
    try {
      localStorage.removeItem(CART_ZIP_STORAGE_KEY);
    } catch (error) {}
  }

  function hardenCartZipInputs() {
    document.querySelectorAll('[data-polly-shipping-zip]').forEach(function (input) {
      hardenCartZipInput(input);
    });
  }

  function addBusinessDays(startDate, businessDays) {
    var date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    var added = 0;

    while (added < businessDays) {
      date.setDate(date.getDate() + 1);
      var weekDay = date.getDay();
      if (weekDay !== 0 && weekDay !== 6) added++;
    }

    return date;
  }

  function formatDateBr(date) {
    return pad(date.getDate()) + '/' + pad(date.getMonth() + 1) + '/' + date.getFullYear();
  }

  function fixCartShippingDateText() {
    document.querySelectorAll('#cartDrawer .polly-cart-shipping__rate-note').forEach(function (element) {
      var text = String(element.textContent || '').trim();
      var match = text.match(/^Entrega estimada:\s*(\d{4})-(\d{2})-(\d{2})$/);
      if (match) {
        element.textContent = 'Entrega estimada até o dia ' + match[3] + '/' + match[2] + '/' + match[1];
      }
    });
  }

  function makeProductLocalLine(label, price, note) {
    var line = document.createElement('div');
    line.className = 'polly-product-local-shipping__line';
    line.style.marginTop = '8px';
    line.style.lineHeight = '1.45';

    var strong = document.createElement('strong');
    strong.textContent = '– ' + label + ': ';
    line.appendChild(strong);
    line.appendChild(document.createTextNode(price + (note ? ' – ' + note : '')));
    return line;
  }

  function ensureProductLocalShippingOptions() {
    document.querySelectorAll('[id="shipping-rates-modal-zip"]').forEach(function (input) {
      var shippingContainer = input.closest('#cart-shipping-rates');
      if (!shippingContainer) return;

      var success = shippingContainer.querySelector('#frete-sucesso');
      if (!success) return;

      var zip = digits(input.value);
      var existing = success.querySelector('[data-polly-product-local-shipping]');

      if (zip.length !== 8 || (!isRecife(zip) && !isUberArea(zip))) {
        if (existing) existing.remove();
        return;
      }

      if (success.hasAttribute('hidden') || !String(success.textContent || '').trim()) {
        if (existing) existing.remove();
        return;
      }

      if (existing && existing.getAttribute('data-polly-product-local-zip') === zip) return;
      if (existing) existing.remove();

      var nativeText = normalized(success.textContent);
      var hasPickup = nativeText.indexOf('retirada') !== -1 || nativeText.indexOf('pickup') !== -1;
      var hasUber = nativeText.indexOf('uber') !== -1;
      var needsPickup = isRecife(zip) && !hasPickup;
      var needsUber = isUberArea(zip) && !hasUber;

      if (!needsPickup && !needsUber) return;

      var wrapper = document.createElement('div');
      wrapper.setAttribute('data-polly-product-local-shipping', '');
      wrapper.setAttribute('data-polly-product-local-zip', zip);
      wrapper.style.marginTop = '2px';

      if (needsPickup) {
        wrapper.appendChild(makeProductLocalLine(
          'Retirada em Recife',
          'Grátis',
          'Retirada disponível para CEPs de Recife.'
        ));
      }

      if (needsUber) {
        wrapper.appendChild(makeProductLocalLine(
          'Uber Flash',
          'A combinar',
          'Entre em contato para combinar o valor e a entrega.'
        ));
      }

      success.appendChild(wrapper);
    });
  }

  function applyProductShippingDateFix() {
    var shipping = null;

    if (typeof theme !== 'undefined' && theme && theme.shipping) {
      shipping = theme.shipping;
    } else if (window.theme && window.theme.shipping) {
      shipping = window.theme.shipping;
    }

    if (!shipping) return false;
    if (shipping.__pollyProductDateFixed) return true;

    shipping.formatDeliveryDays = function (deliveryDays) {
      if (!deliveryDays || !deliveryDays.length) return '';

      var lastDay = Number(deliveryDays[deliveryDays.length - 1]);
      if (!isFinite(lastDay) || lastDay < 0) return '';

      var estimatedDate = addBusinessDays(new Date(), lastDay);
      return '- Entrega estimada até o dia ' + formatDateBr(estimatedDate);
    };

    shipping.__pollyProductDateFixed = true;
    return true;
  }

  function refreshEnhancements() {
    hardenCartZipInputs();
    fixCartShippingDateText();
    ensureProductLocalShippingOptions();
  }

  function initialize() {
    refreshEnhancements();

    if (!applyProductShippingDateFix()) {
      var attempts = 0;
      var timer = setInterval(function () {
        attempts++;
        if (applyProductShippingDateFix() || attempts >= 50) {
          clearInterval(timer);
        }
      }, 100);
    }
  }

  document.addEventListener('pointerdown', function (event) {
    var input = cartZipInput(event.target);
    if (!input) return;
    hardenCartZipInput(input);
  }, true);

  document.addEventListener('focusin', function (event) {
    var input = cartZipInput(event.target);
    if (!input) return;
    hardenCartZipInput(input);
  }, true);

  document.addEventListener('input', function (event) {
    var cartInput = cartZipInput(event.target);
    if (cartInput) {
      hardenCartZipInput(cartInput);
      forgetStoredCartZip();
      return;
    }

    if (!event.target || event.target.id !== 'shipping-rates-modal-zip') return;
    var container = event.target.closest('#cart-shipping-rates');
    var success = container && container.querySelector('#frete-sucesso');
    var existing = success && success.querySelector('[data-polly-product-local-shipping]');
    if (existing) existing.remove();
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('#shipping-rates-modal-btn') : null;
    if (!button) return;
    window.setTimeout(refreshEnhancements, 150);
    window.setTimeout(refreshEnhancements, 600);
    window.setTimeout(refreshEnhancements, 1500);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  new MutationObserver(function () {
    refreshEnhancements();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['hidden']
  });
})();
